import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 操作记录
interface RecordJson {
    type: string,
    relation_id: string,
}

export const record = (json: RecordJson): any => http.httpPost({
    url: httpApi.operation.record,
    json
})

// 用户行为记录
interface FootprintJson {
    module_index: string,
    deed: string,
    relation_id: string,
}

export const footprint = (json: FootprintJson): any => http.httpPost({
    url: httpApi.operation.footprint,
    json
})
